import { Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';

const Container = styled.div`
  width: ${(props) => props.wid || '100%'};
  margin: ${(props) => props.marg || '0'};

  .ql-editor {
    max-height: ${(props) => props.editorHt || '250px'};
  }
`;

const EditorContainer = styled.div`
  ${(props) => `
    border: ${props.focused ? '1px' : `1px solid ${theme.GREY_50}`};
    outline: ${props.focused ? '#000 solid 2px' : `0`};
    border-radius: 15px;
  `}
`;

const CustomTextEditor = (props) => {
  const [focused, setFocused] = useState(false);

  return (
    <Container {...props}>
      {props.title && (
        <Text b2 med marg={props.rounded ? '0 0 8px' : '0 0 4px 16px'}>
          {props.title}
        </Text>
      )}

      <EditorContainer {...props} focused={focused}>
        <ReactQuill
          {...props}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{ width: '100%' }}
        />
      </EditorContainer>
    </Container>
  );
};

export default CustomTextEditor;
